module.exports = __webpack_public_path__ + "assets/img/station8.837d6d1d.png";